//import app from 'firebase/app';
 
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";


const config = {
    apiKey: "AIzaSyAylVc1-k-1b1A2JSujfmJ0hNeXWgFzylg",
    authDomain: "within1hour-1483711039788.firebaseapp.com",
    databaseURL: "https://within1hour-1483711039788.firebaseio.com",
    projectId: "within1hour-1483711039788",
    storageBucket: "within1hour-1483711039788.appspot.com",
    messagingSenderId: "927388276112"
};
 
// class Firebase {
//   constructor() {
//     app.initializeApp(config);
//   }
// }
 
// export default Firebase;

const app = initializeApp(config);
export const db = getDatabase(app);